// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Package20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Package20Filled: FC<Package20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M9.25 17.813v-7.375L3 6.832v6.5c0 .278.066.528.198.75.132.223.316.403.552.542l5.5 3.188Zm1.5 0 5.5-3.188c.236-.139.42-.32.552-.542.132-.222.198-.472.198-.75v-6.5l-6.25 3.604v7.376Zm3.167-10.959 2.458-1.417-5.625-3.229a1.456 1.456 0 0 0-1.5 0l-1.688.98 6.355 3.666ZM10 9.125l2.438-1.396-6.396-3.687-2.438 1.416L10 9.125Z" />
        </svg>
    );
};

export default Package20Filled;
